export function isIe11() {
  return navigator.userAgent.match(/Trident.*rv:11/);
}
